import { useEffect, useState } from 'react';

/**
 * Siamo su un telefono? La soglia è 768px, la stessa di mobile.css.
 *
 * Da usare SOLO quando serve cambiare la STRUTTURA (un componente che su
 * telefono rende un albero diverso, per esempio i filtri che si spostano dentro
 * un pannello). Per tutto il resto — dimensioni, ordine, cosa si vede e cosa no
 * — si usa il CSS: una media query non fa render, non ha un istante in cui
 * mostra la cosa sbagliata, e non finisce nel bundle.
 */
const QUERY = '(max-width: 768px)';

export function useIsMobile(): boolean {
  const [is, setIs] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const apply = () => setIs(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  return is;
}
